import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderLink2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolderLink2"><Path d="M10.4014 3H2V11.5H13.5V20H22V6H12.4014L10.4014 3Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M4.5 16.25H8.5V17.75H4.5V16.25Z" fill="currentColor"/><Path d="M1 13V21H5.5V19.5H2.5V14.5H5.5V13H1Z" fill="currentColor"/><Path d="M12 13V21H7.5V19.5H10.5V14.5H7.5V13H12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderLink2;
